import {useRouteError, Navigate} from 'react-router-dom';

export const ErrorHandler = () => {
  const error = useRouteError();

  return <Navigate to="/error" state={error} />;
};

export default ErrorHandler;
